import { newAxiosIns } from '@/libs/axios'
import { axiosKomship } from '../helpers'

const POLLING_INTERVAL_MS = 300000
let pollingTimeoutId = null
let isFetching = false

const clearPollingTimer = () => {
  if (!pollingTimeoutId) return
  clearTimeout(pollingTimeoutId)
  pollingTimeoutId = null
}

/**
 * Store for the unpacked orders badge and manage the polling of the unpacked orders badge
 */
export default {
  namespaced: true,
  state: () => ({
    isPolling: false,
    komship: 0,
    nonKomship: 0,
    marketplace: 0,
  }),
  mutations: {
    SET_ALL_BADGE(state, value) {
      state.komship = value.komship
      state.nonKomship = value.non_komship
      state.marketplace = value.marketplace
    },
    SET_POLLING_STATE(state, value) {
      state.isPolling = value
    },
  },
  actions: {
    /**
     * Fetch the unpacked orders badge and spread the data to the state
     */
    async fetchUnpackedOrdersBadge({ commit }) {
      if (isFetching) return
      isFetching = true

      try {
        const { data } = await newAxiosIns.get('/komship/api/v1/orders/submitted/count')
        commit('SET_ALL_BADGE', data.data)
      } catch (error) {
        const message = error?.response?.data?.message
    || error?.message
    || 'Failed to fetch total unpacked orders'
        if (process.env.NODE_ENV !== 'production') {
          console.error('[unpacked_orders/fetchTotalUnpackedOrders]', message)
        }
      } finally {
        isFetching = false
      }
    },

    /**
     * Start the polling to fetch the unpacked orders badge every interval
     */
    startPolling({ state, commit, dispatch }) {
      if (state.isPolling) return

      commit('SET_POLLING_STATE', true)
      clearPollingTimer()

      const run = async () => {
        await dispatch('fetchUnpackedOrdersBadge')

        if (!state.isPolling) return
        pollingTimeoutId = setTimeout(run, POLLING_INTERVAL_MS)
      }

      run()
    },

    /**
     * Stop the polling to fetch the unpacked orders badge
     */
    stopPolling({ commit }) {
      commit('SET_POLLING_STATE', false)
      clearPollingTimer()
    },
  },
}
